import { ActionRules } from '../types';
import recognition from './recognition';

export default class AccessChecker {
  rules: ActionRules;

  serviceName: string;

  constructor(rules: ActionRules, serviceName: string) {
    this.rules = rules;
    this.serviceName = serviceName;
  }

  isGranted(action: string, ...args: any[]): boolean {
    const rule = this.rules[action];
    if (rule.accountTypes && rule.accountTypes.length) {
      const accountType = recognition.getAccountType();
      if (accountType === null || !rule.accountTypes.includes(accountType)) return false;
    }
    if (rule.scope && !recognition.hasScope(rule.scope, this.serviceName)) return false;
    if (rule.check) {
      return rule.check(...args);
    }
    return true;
  }
}
